import type { AutoHealingRow } from '../../enterprisedevops/framework';

type Props = { actions?: AutoHealingRow[] };

export function AutoHealingPanel({ actions = [] }: Props) {
  return (
    <div className="space-y-2">
      {actions.map((a) => (
        <div key={a.action} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div>
            <p className="text-sm font-medium">{a.action}</p>
            <p className="text-xs text-slate-500">{a.trigger}</p>
          </div>
          <div className="text-right">
            <p className="text-sm font-semibold">{a.count}x</p>
            <span className="text-xs font-medium text-success-600">{a.status}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
